// URL for a run that is still generating.
//
// A finished run is addressed by path (/ai-3d-model-generator/3d-models/<slug>, see
// buildSharedRunPathname), but an in-flight run cannot be: ThreeDStudioController#index
// resolves `params[:slug]` through `Generator::Run.succeeded.find_by(slug:)`, so a run
// that is still processing - and has no slug yet, since one is assigned on completion -
// resolves to nil and the request is redirected to /ai with the "This 3D model is no
// longer available" alert. Refreshing mid-generation used to land exactly there.
//
// Keeping the run in a query parameter on /ai leaves `params[:slug]` blank, so the
// controller returns early and never looks anything up, while the URL still names the
// run the studio should highlight and recommend for.
const GENERATING_RUN_PARAM = 'run'

export const buildGeneratingRunUrl = (runId) => (
  runId == null ? '/ai' : `/ai?${GENERATING_RUN_PARAM}=${encodeURIComponent(runId)}`
)

/**
 * Reads the in-flight run id from a location search string.
 * @param {string} [search] - location.search, with or without the leading '?'
 * @returns {number|null} the run id, or null when the parameter is absent or malformed
 */
export const parseGeneratingRunId = (search) => {
  if (typeof search !== 'string' || search === '') {
    return null
  }

  const raw = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
    .get(GENERATING_RUN_PARAM)
  if (raw == null || raw.trim() === '') {
    return null
  }

  const parsed = Number(raw)
  return Number.isFinite(parsed) ? parsed : null
}
